import { lazy, Route } from '@tanstack/router'

import { freeBonusRoute } from '.'

const FreeBonus = lazy(
  () => import('../../../pages/profile/free-bonus/free-bonus'),
)

export type FreeBonusSearch = {
  activeTab?: number
}

export const freeBonusIndexRoute = new Route({
  getParentRoute: () => freeBonusRoute,
  path: '/',
  component: FreeBonus,
  validateSearch: (search: Record<string, unknown>): FreeBonusSearch => {
    return search.activeTab ? { activeTab: +search.activeTab } : {}
  },
})
